// Generated by CoffeeScript 2.7.0
var Fieldable;

import Field from '../field/index.js';

export default Fieldable = {
  moveFieldTo: function(currentIndex, targetIndex) {
    var field;
    field = this.fields.splice(currentIndex, 1)[0];
    return this.fields.splice(targetIndex, 0, field);
  },
  insertField: function(field, index = 0) {
    return this.fields.splice(index, 0, field);
  },
  getDisappearedFieldIdsOnInit: function() {
    return _.chain(this.fields).map(function(field) {
      return typeof field.getDisappearedFieldIdsOnInit === "function" ? field.getDisappearedFieldIdsOnInit() : void 0;
    }).flatten().uniq().compact().value();
  },
  _makeFields: function(fields, logic = {}) {
    var logic_settings;
    logic_settings = logic.valid ? logic.constraints || {} : {};
    return this.fields = _.chain(fields).sortBy('position').compact().map((field) => {
      return Field.Base.new(field, logic_settings, this);
    }).value();
  },
  _generateFieldAttributes: function() {
    return _.map(this.fields, function(field, index) {
      field.position = index;
      return field.toJSON();
    });
  }
};
